// extracted by mini-css-extract-plugin
module.exports = {"Container":"FilteredServices_Container__2YHNN","Service":"FilteredServices_Service__ID5hE","NotFound":"FilteredServices_NotFound__3xnIi","Image":"FilteredServices_Image__1atEz"};